import {
	call, delay, put, race, takeEvery,
} from "redux-saga/effects";
import { objectToQueryString } from "helpers/queryString";
import Env from "../../../consts/env";
import {
	ActionsSearchResult,
	failureSearchResult, loadGetSearchResult, loadSearchResultSuccess,
} from "./actions";

function* loadDataSearchResult(params = {}) {

	try {

		yield put(loadGetSearchResult());

		const queryParams = objectToQueryString({
			...(!params.payload.next_id ? { page: params.payload.page } : { page: 1 }),
			...(params?.payload?.type && { type: params.payload.type }),
			...(params?.payload?.sort && { sort: params.payload.sort }),
			...(params?.payload?.keyword && {keyword: params.payload.keyword}),
			...(params?.payload?.limit && {limit: params?.payload?.limit}),
			...(params?.payload?.next_id && {next_id: params.payload.next_id})
		});

		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getSearchResult?${queryParams}`;

		const headers = { ...Env.HEADERS, page: params.payload.page };
		const method = "GET";
		const options = { headers, method };

		const { timeout, response } = yield race({
			timeout: delay(30000),
			response: call(fetch, endpoint, options),
		});

		if (timeout) {

			yield put(failureSearchResult(yield "Error Timeout..."));

		} else {

			const dataSearchResult = yield response.json();

			if (response.status !== 200) {

				yield put(failureSearchResult(yield response.statusText));

			} else {

				yield put(loadSearchResultSuccess(yield dataSearchResult));

			}

		}

	} catch (err) {

		yield put(failureSearchResult(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsSearchResult.GET_SEARCH_RESULT, loadDataSearchResult);

}
